<template>
    <div class="row" v-for="category in categories" :key="category.id">
    <CategoryColorComponent :title="$t('catalog.categories.' + category.name)" />
    <div
      class="col-6 col-lg-3"
      v-for="rose in otherCategories(category.name)"
      :key="rose.id"
      id="rose-col"
    >
      <RoseComponent
        :rose-name="rose.name"
        :length="rose.length"
        :bloom="rose.bloom"
        :petals="rose.petals"
        :vaselife="rose.vaselife"
        :img="require(`../assets/roses/` + rose.img)"
      />
    </div>
  </div>
</template>

<script>
import RoseComponent from './RoseComponent.vue';
import CategoryColorComponent from './CategoryColorComponent.vue';
import otherRosesArray from '../data/other-roses.json';
import categoriesArray from '../data/other-categories.json'
export default {
    name: "OtherRosesList",
    components: {
        RoseComponent,
        CategoryColorComponent
    },
    data () {
        return {
            otherRoses: otherRosesArray,
            categories: categoriesArray
        }
    },
    methods: {
        otherCategories(category) {
            return this.otherRoses.filter((rose) => rose.category === category);
        }
    }
}
</script>